import { render, staticRenderFns } from "./bhpAside.vue?vue&type=template&id=d4543218&scoped=true&"
import script from "./bhpAside.vue?vue&type=script&lang=js&"
export * from "./bhpAside.vue?vue&type=script&lang=js&"
import style0 from "./bhpAside.vue?vue&type=style&index=0&id=d4543218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4543218",
  null
  
)

export default component.exports